import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAdminUser } from '@/lib/role-guards'
import { AdminBirthdaysPage } from '@/features/admin/birthdays'

export const Route = createFileRoute('/_authenticated/admin/birthdays')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AdminBirthdaysPage,
})
